import { HOTEL_HOVERED, HOTEL_CLICKED } from '../constants/hotels';

export const hotelHovered = (payload) => ({
  type: HOTEL_HOVERED,
  payload,
});

export const hotelClickedAction = () => ({
  type: HOTEL_CLICKED,
});
